import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  lotData: [],
}

export const lotData = createSlice({
  name: 'lotData',
  initialState,
  reducers: {
    setLotData: (state, { payload }) => {
      state.lotData = payload
    },
  },
})

export const {setLotData} = lotData.actions;